
class collectionGridItem extends HTMLElement {
    constructor() {
        super();
        this.mainCollection = document.querySelector('[js-main-collection]');
        this.desktopPosition = parseInt(this.dataset.positionDesk);
        this.mobilePosition = parseInt(this.dataset.positionMob);
        this.init();
    }
    init() {
        this.appendGridItem()
    }
    appendGridItem() {
        const targetProductItem = this.mainCollection.querySelector(`[js-product-card] .f-column:nth-child(${document.documentElement.clientWidth > 767 ? this.desktopPosition : this.mobilePosition})`);
       console.log(targetProductItem,'targetProductItem');
       
        if(targetProductItem) {
            targetProductItem.insertAdjacentHTML("beforebegin",this.innerHTML)
        }
    };
}

customElements.define('collection-grid-item', collectionGridItem);